<!-- LayoutCol.vue -->
<template>
    <div :class="colClasses">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LayoutCol',
    props: {
        span: {
            type: [Number, String],
            default: '12',
        },
        sm: {
            type: [Number, String],
            default: null,
        },
        md: {
            type: [Number, String],
            default: null,
        },
        lg: {
            type: [Number, String],
            default: null,
        },
        xl: {
            type: [Number, String],
            default: null,
        },
    },
    computed: {
        colClasses() {
            const classes = [];

            if (this.span === 'auto') {
                classes.push('col-auto');
            } else {
                classes.push(`col-span-${this.span}`);
            }

            if (this.sm) {
                classes.push(`sm:col-span-${this.sm}`);
            }
            if (this.md) {
                classes.push(`md:col-span-${this.md}`);
            }
            if (this.lg) {
                classes.push(`lg:col-span-${this.lg}`);
            }
            if (this.xl) {
                classes.push(`xl:col-span-${this.xl}`);
            }

            return classes;
        },
    },
};
</script>
